/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecuteReportResponse
 */
export interface ExecuteReportResponse {
    /**
     * 
     * @type {string}
     * @memberof ExecuteReportResponse
     */
    executionId: string;
}

/**
 * Check if a given object implements the ExecuteReportResponse interface.
 */
export function instanceOfExecuteReportResponse(value: object): value is ExecuteReportResponse {
    if (!('executionId' in value) || value['executionId'] === undefined) return false;
    return true;
}

export function ExecuteReportResponseFromJSON(json: any): ExecuteReportResponse {
    return ExecuteReportResponseFromJSONTyped(json, false);
}

export function ExecuteReportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecuteReportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'executionId': json['executionId'],
    };
}

export function ExecuteReportResponseToJSON(json: any): ExecuteReportResponse {
    return ExecuteReportResponseToJSONTyped(json, false);
}

export function ExecuteReportResponseToJSONTyped(value?: ExecuteReportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'executionId': value['executionId'],
    };
}

